module.exports = __webpack_public_path__ + "img/acportal.22ecb03b.svg";